import React from "react"

export interface HelmetAttributes {
  htmlAttributes?: { lang?: string }
  title?: string
  link?: { rel: string; href: string; type: string }[]
  meta?: (
    | { name: string; content: string }
    | { property: string; content: string }
  )[]
}

export const HelmetContext = React.createContext<
  ((attributes: HelmetAttributes) => void) | null
>(null)
